import React, { useState } from 'react';
import { useOrder } from 'hooks/api/scheduling/useOrder';
import { DataTable } from 'components/ui/DataTable';
import { useColumns } from './columns';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'hooks/auth';
import { Button } from 'components/ui/button';
import { Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type Filters = {
  formFilter: any[];
  statusFilter: string[];
};

export const ListRejectedOrders: React.FC = () => {
  const { columns } = useColumns();
  const { getOrders } = useOrder();
  const { userBelongsToAnyOf } = useAuth();
  const navigate = useNavigate();

  const [filters, setFilters] = useState<Filters>({
    formFilter: [],
    statusFilter: ['rejeitado'],
  });

  const { isPending, error, data } = useQuery({
    queryKey: ['getPendingOrders', filters],
    queryFn: () => getOrders(filters),
  });

  const actionButton = (
    <Button
      variant="outline"
      size="sm"
      className="w-full max-w-full md:max-w-max h-8 font-GilroySemibold lg:flex bg-green-600 text-white hover:bg-green-500 hover:text-white duration-300"
      onClick={() => navigate('/agendamento/criar-solicitacao-estoque')}
    >
      <Calendar className="mr-2 h-4 w-4" />
      Nova Solicitação
    </Button>
  );

  if (error) return <div>An error occurred: {(error as Error).message}</div>;

  return (
    <>
      <DataTable
        columns={columns}
        data={data || []}
        isLoading={isPending}
        actionButton={actionButton}
      />
    </>
  );
};
